import useAsyncData from "../../../../hooks/use-async-data";
import taxiCorporationService from "../../taxi-corporation.service";
import TaxiCorporationUnbilledRouteList from "./taxi-corporation-unbilled-route-list";
import TaxiCorporationUnbilledRouteListParams from "./taxi-corporation-unbilled-route-list-params";

const useTaxiCorporationUnbilledRouteList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<TaxiCorporationUnbilledRouteList | null>(null);

  const load = async (
    params: TaxiCorporationUnbilledRouteListParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false), setIsLoading(true);

    try {
      const data = await taxiCorporationService.getUnbilledRouteListing(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useTaxiCorporationUnbilledRouteList;
